export const historicalPerformancePlaceholder = [
  {
    x: [
      'Apr 2022',
      'May 2022',
      'Jun 2022',
      'Jul 2022',
      'Aug 2022',
      'Sep 2022',
      'Oct 2022',
      'Nov 2022',
      'Dec 2022',
      'Jan 2023',
      'Feb 2023',
      'Mar 2023',
    ],
    y: [
      { investedCapital: 110000, netGain: 10000, deployedCapital: 50000 },
      { investedCapital: 120000, netGain: 20000, deployedCapital: 50000 },
      { investedCapital: 130000, netGain: 30000, deployedCapital: 50000 },
      { investedCapital: 140000, netGain: 40000, deployedCapital: 50000 },
      { investedCapital: 150000, netGain: 50000, deployedCapital: 50000 },
      { investedCapital: 160000, netGain: 60000, deployedCapital: 50000 },
      { investedCapital: 170000, netGain: 70000, deployedCapital: 50000 },
      { investedCapital: 180000, netGain: 80000, deployedCapital: 50000 },
      { investedCapital: 190000, netGain: 90000, deployedCapital: 50000 },
      { investedCapital: 200000, netGain: 100000, deployedCapital: 50000 },
      { investedCapital: 210000, netGain: 110000, deployedCapital: 50000 },
      { investedCapital: 220000, netGain: 120000, deployedCapital: 50000 },
    ],
  },
];
